import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../src/components/Table/Table';
import { CircularProgress, Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const UserWorkoutsTable = ({ workouts, loading }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (workouts.length === 0) {
    return <Typography>No workouts found.</Typography>;
  }

  const columns = [
    { title: 'Workout Name', field: 'name' },
    { title: 'Description', field: 'description' },
    {
      title: 'Equipment Needed',
      field: 'equipmentNeeded',
      render: (rowData) =>
        rowData.equipmentNeeded ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
    { title: 'Category', field: 'categoryName' },
    {
      title: 'Reviewed',
      field: 'isReviewed',
      render: (rowData) =>
        rowData.isReviewed ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
    {
      title: 'Approved',
      field: 'isApproved',
      render: (rowData) =>
        rowData.isApproved ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
  ];

  return (
    <Table
      title="User Workouts"
      columns={columns}
      data={workouts}
      options={{
        paging: true,
        search: true,
        sorting: true,
      }}
    />
  );
};

UserWorkoutsTable.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string.isRequired,
      isReviewed: PropTypes.bool.isRequired,
      isApproved: PropTypes.bool.isRequired,
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default UserWorkoutsTable;
